import { Printer } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

export const LabelDialog = ({ car, onOpenChange }) => {
  const { t, fmt, lang } = useI18n();
  if (!car) return null;
  return (
    <Dialog open={!!car} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="label-dialog">
        <DialogHeader className="no-print"><DialogTitle>{t("shelfLabel")}</DialogTitle></DialogHeader>
        <div id="label-print" dir={lang === "ar" ? "rtl" : "ltr"} className="border-4 border-slate-900 rounded-xl p-6 text-center space-y-4 bg-white">
          <div className="text-sm font-bold text-slate-500">{t("appName")}</div>
          <div>
            <div className="text-lg font-bold">{t("shelf")}</div>
            <div className="text-8xl font-black leading-none" data-testid="label-shelf-number">{car.shelf_number}</div>
          </div>
          <div className="border-t-2 border-dashed border-slate-400 pt-4 space-y-2">
            <div className="text-sm text-slate-500">{t("plate")}</div>
            <div className="plate text-3xl" data-testid="label-plate">{car.plate_number}</div>
            <div className="font-bold">{car.car_type}</div>
            <div className="text-xs text-slate-500">{fmt(car.history[0]?.date)}</div>
          </div>
        </div>
        <div className="no-print flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t("close")}</Button>
          <Button data-testid="label-print-btn" onClick={() => window.print()}><Printer className="w-4 h-4" />{t("print")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
